import { supabase } from '@/core/database/supabase';
import type { AutomationRule, AutomationLog } from '../types/automation.types';

export const ConstructionAutomationService = {
  /**
   * Danh sách quy tắc tự động hóa
   */
  async getRules(companyId: string, projectId?: string): Promise<AutomationRule[]> {
    let query = supabase
      .from('construction_automation_rules')
      .select('*')
      .eq('company_id', companyId);

    if (projectId) query = query.eq('project_id', projectId);

    const { data, error } = await query.order('created_at', { ascending: false });

    if (error) {
      // Mock data if table doesn't exist
      return [
        {
          id: '1',
          company_id: companyId,
          name: 'Tự động nhắc báo cáo ngày',
          description: 'Gửi thông báo cho Foreman lúc 17:00 nếu chưa nộp nhật ký.',
          trigger_code: 'daily_report_missing',
          action_code: 'send_notification',
          is_enabled: true,
          created_at: new Date().toISOString()
        },
        {
          id: '2',
          company_id: companyId,
          name: 'QA Fail tự tạo Issue',
          description: 'Khi hạng mục nghiệm thu không đạt, tự động tạo sự cố NCR.',
          trigger_code: 'qa_failed',
          action_code: 'create_issue',
          is_enabled: true,
          created_at: new Date().toISOString()
        }
      ];
    }
    return data as AutomationRule[];
  },

  /**
   * Lưu quy tắc mới hoặc cập nhật
   */
  async saveRule(rule: Partial<AutomationRule>): Promise<void> {
    const { error } = await supabase
      .from('construction_automation_rules')
      .upsert([rule]);

    if (error) throw error;
  },

  /**
   * Bật/Tắt quy tắc
   */
  async toggleRule(id: string, isEnabled: boolean): Promise<void> {
    const { error } = await supabase
      .from('construction_automation_rules')
      .update({ is_enabled: isEnabled })
      .eq('id', id);

    if (error) throw error;
  },

  /**
   * Nhật ký chạy tự động hóa
   */
  async getLogs(companyId: string, ruleId?: string): Promise<AutomationLog[]> {
    let query = supabase
      .from('construction_automation_logs')
      .select('*, rule:construction_automation_rules(name)')
      .eq('company_id', companyId);

    if (ruleId) query = query.eq('rule_id', ruleId);

    const { data, error } = await query.order('executed_at', { ascending: false }).limit(50);
    
    if (error) return [];
    return data as any[];
  }
};
